module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-main home-page"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "ui-col-5 left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/all-order-bill',
        query: {
          bill_state: '10',
          'bill_font': '未处理'
        }
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countShow(_vm.count.order_unhandled_num)),
      expression: "countShow(count.order_unhandled_num)"
    }],
    staticClass: "num green"
  }, [_vm._v(_vm._s(_vm.count.order_unhandled_num) + "张")]), _vm._v(" "), _c('span', {
    staticClass: "msg"
  }, [_vm._v("未处理订单")])])], 1), _c('div', {
    staticClass: "ui-col-5 right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/all-order-bill',
        query: {
          bill_state: '11',
          'bill_font': '待发货'
        }
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countShow(_vm.count.order_accept_num)),
      expression: "countShow(count.order_accept_num)"
    }],
    staticClass: "num red"
  }, [_vm._v(_vm._s(_vm.count.order_accept_num) + "张")]), _vm._v(" "), _c('span', {
    staticClass: "msg"
  }, [_vm._v("待发货订单")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": {
        path: '/bill-count',
        query: {
          bill_state: '12,21',
          end_date: _vm.end_date,
          length: 10,
          restaurant_id: '',
          start: 0,
          start_date: _vm.start_date
        }
      }
    }
  }, [_c('span', {
    staticClass: "msg"
  }, [_vm._v("单据统计")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "main main1"
  }, [_c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": {
        path: '/goods-company-summary'
      }
    }
  }, [_c('span', {
    staticClass: "msg"
  }, [_vm._v("货品汇总")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "main main2"
  }, [_c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": {
        path: '/goods-money-summary'
      }
    }
  }, [_c('span', {
    staticClass: "msg"
  }, [_vm._v("金额汇总")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "main main1"
  }, [_c('router-link', {
    staticClass: "ui-btn-icon-right ui-icon-carat-r",
    attrs: {
      "to": {
        path: '/goods-company-summary',
        query: {
          shortcut: 1
        }
      }
    }
  }, [_c('span', {
    staticClass: "msg"
  }, [_vm._v("今日货品汇总")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "main-banner fx-festival-home-banner"
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c4ebb218!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 618
// module chunks = 1